import http from "./http"; // needs this file in the same directory
import { The_Ability } from "../store/index";

// const
export default {
  index(filter) {
    return http.get(`/ghost_executions`, { params: filter });
  },

  showTk(item_id, filter) {
    // console.log({filter});
    return http.get(`/ghost_executions/${item_id}${filter? ('?'+filter) : ''}`);
  },

  show(item_id, tk) {
    // console.log({filter});
    return http.get(`/ghost_executions/${item_id}`, {
      headers: {
        authorization: `Bearer ${tk}`
      },
    });
  },

  getDoneFormPDF(id){
    return http.get("/ghost_executions/"+id+".pdf", { responseType: 'blob' })
  },

  create(new_item) {
    let {done_items, ...ni} = new_item
    done_items = done_items.map(done_item=> {
      let {photo_compressed, ...di} = done_item
      if (photo_compressed && photo_compressed.length && Array.isArray(photo_compressed)) {
        photo_compressed = photo_compressed.filter(pc=> (!pc.id && pc.data) || (typeof pc === 'string') )
      }
      return {
        ...di,
        photo_compressed
      }
    })

    return http.post(`/ghost_executions`, {
      done_form: {
        name: new_item.name,
        score: new_item.score,
        description: new_item.description,
        settings: new_item.settings,
        department_id: new_item.department_id,
        solution_id: new_item.solution_id,

        task_id: new_item.task_id,

        user_id: new_item.user_id,
        form_id: new_item.form_id,
        done_at: new_item.done_at,

        coordinates: new_item.coordinates,
        latitude: new_item.latitude,
        longitude: new_item.longitude,
        started_at: new_item.started_at,
        elapsed_time: new_item.elapsed_time,

        email_notification_enabled: new_item.email_notification_enabled,
        with_extra_emails:          new_item.with_extra_emails,
        extra_emails_mandatory:     new_item.extra_emails_mandatory,
        extra_emails:               new_item.extra_emails,

        done_items_attributes: new_item.done_items,

        is_partial: new_item.is_partial || false,
        state: new_item.state,
      },
    },
    {
      headers: {
        authorization: `true`
      },
    });
  },

  update(update_item) {
    // if (The_Ability.can('update', 'DoneForm')){
    // console.log({update_item});

    let {done_items, ...ni} = update_item
    if (done_items && done_items.length){
      done_items = done_items.map(done_item=> {
        let {photo_compressed, signature_img, ...di} = done_item
        // console.log({photo_compressed});
        if (photo_compressed && photo_compressed.length && Array.isArray(photo_compressed)) {
          photo_compressed = photo_compressed.filter(pc=> (!pc.id && pc.data) || (typeof pc === 'string') )
          // console.log({photo_compressed})
        }
        if (signature_img && signature_img.length) {
          if (signature_img.includes('http')){
            signature_img = null
          }
        }
        let obj = {
          ...di,
          photo_compressed,
        }
        if (signature_img){
          obj = {...obj, signature_img}
        }
        return obj
      })
    }

    return http.put(`/ghost_executions/${update_item.id}`, {
      done_form: {
        id: update_item.id,

        is_partial: update_item.is_partial || false,
        state: update_item.state,
        score: update_item.score,

        // name: update_item.name,
        // description: update_item.description,
        // settings: update_item.settings,
        // department_id: update_item.department_id,
        // solution_id: update_item.solution_id,

        // coordinates: update_item.coordinates,
        // latitude: update_item.latitude,
        // longitude: update_item.longitude,
        done_at: update_item.done_at,
        started_at: update_item.started_at,
        elapsed_time: update_item.elapsed_time,

        task_id: update_item.task_id,

        // email_notification_enabled: update_item.email_notification_enabled,
        // with_extra_emails:          update_item.with_extra_emails,
        // extra_emails_mandatory:     update_item.extra_emails_mandatory,
        extra_emails:               update_item.extra_emails,

        done_items_attributes: done_items,
      },
    },
    {
      headers: {
        authorization: `true`
      },
    });
    // } else {
    // return false
    // }
  },

  updateToDelete(update_item) {
    return http.delete(`/ghost_executions/${update_item}`);
  },
  delete(update_item) {
    return http.delete(`/ghost_executions/${update_item}`);
  },
};
